import type { ScalePulseTuning, WinHighlightTuning } from "@slot/presentation";

// The win presentation's VALUES — the only file to edit to retune it: the cluster highlight (the dim on the rest of
// the board, the amount label at the cluster), the winners' pulse, the beat before each win and the hold before an
// auto-advanced spin. The shapes are the platform's (`WinHighlightTuning`, `ScalePulseTuning`, the shell's win
// sequence and auto-advance). A cluster's label shows at the cluster (a merge game's wins move the eye around the
// board), one per cluster — "base × multiplier", then its total, when its cells' badges multiplied it — and fades: the
// title has no win meter to collect into (the bar's WIN shows the total).

export interface WinPresentationTuning {
  layer: WinHighlightTuning;
  label: { hideSeconds: number; multiplier: { holdSeconds: number; popSeconds: number; popScale: number } };
  scalePulse: ScalePulseTuning;
  winHighlightDelay: { firstSeconds: number; subsequentSeconds: number };
  autoAdvance: { postWinHoldSeconds: number; postRoundHoldSeconds: number };
}

export const WIN_PRESENTATION_TUNING: WinPresentationTuning = {
  layer: {
    cycleDurationMilliseconds: 520,
    dimStartDelayMilliseconds: 0,
    dimFadeSeconds: 0.12,
    dimExposure: -0.55,
    dimFadeEasing: "quadOut",
    dimWinners: false,
    dimEndStartDelayMilliseconds: 0,
    dimEndFadeSeconds: 0.18,
    labelInStartDelayMilliseconds: 80,
    labelOutStartDelayMilliseconds: 1200,
    labelMergeLingerMilliseconds: 400,
    labelPlacement: "clusterCenter",
    labelMode: "perWin",
    // A win's cells pulse together, none waiting on its neighbour (user, 2026-10-10).
    symbolAnimStaggerMilliseconds: 0,
    awaitSymbolWinAnimations: true,
  },
  // A multiplied cluster's label: "base × multiplier" for `holdSeconds`, then a pop to its total.
  label: { hideSeconds: 0.25, multiplier: { holdSeconds: 0.45, popSeconds: 0.24, popScale: 1.25 } },
  scalePulse: {
    uniformScale: true,
    scaleInStartDelayMilliseconds: 40,
    squeezeFactor: 1,
    squeezeSeconds: 0.06,
    squeezeEasing: "quadOut",
    scaleFactor: 1.18,
    scaleUpSeconds: 0.12,
    scaleUpEasing: "quadOut",
    scaleHoldSeconds: 0.06,
    scaleDownSeconds: 0.12,
    scaleDownEasing: "quadIn",
  },
  winHighlightDelay: { firstSeconds: 0.15, subsequentSeconds: 0.05 },
  autoAdvance: { postWinHoldSeconds: 0.5, postRoundHoldSeconds: 0.25 },
};
